import React from 'react';
import { Tooltip } from '@ds';
import { ServiceAccount } from '@account-settings/types';

export const getFilteredServiceAccounts = (
  serviceAccounts: ServiceAccount[] = [],
  filterValue = ''
) => {
  if (!filterValue?.length) {
    return serviceAccounts;
  }

  return serviceAccounts.filter(account =>
    account.name.toLowerCase().includes(filterValue.toLowerCase())
  );
};

export const getFormattedServiceAccounts = (
  serviceAccounts: ServiceAccount[] = []
) => {
  return serviceAccounts.map(account => {
    const { defaultWorkspaceName, authorizedWorkspaces } = account;
    const authorizedWorkspacesString = authorizedWorkspaces?.join(', ');
    return {
      ...account,
      defaultWorkspaceName: (
        <Tooltip
          content={defaultWorkspaceName}
          truncateOverflow
          data-testid="default-workspace-tooltip"
        >
          <span>{defaultWorkspaceName}</span>
        </Tooltip>
      ),
      authorizedWorkspaces: (
        <Tooltip
          content={authorizedWorkspacesString}
          truncateOverflow
          data-testid="authorized-workspaces-tooltip"
        >
          <span>{authorizedWorkspacesString}</span>
        </Tooltip>
      )
    };
  });
};
